/** 导购banner */
import * as React from "react";
import { ZoomSlidingBox, ZoomSlidingCardBox } from "./styles.index";
import { TBannerItem } from "../../../services/banner";
import { LinkTargetType, TModuleWithImgProps } from "../../../services/playground";
import ImageView from "../../../components/SmartImage";
import { transformAParam } from "utils/browser";
import { TBannerItemNew } from "utils/playground/banner";

export interface CubeBannerProps extends TModuleWithImgProps {
	elements: TBannerItem[];
}
const CubeBannerBase = (props: CubeBannerProps) => {
	const { elements, positionId, placeholderBg, aTarget = LinkTargetType.Blank, isInApp } = props;

	return (
		<ZoomSlidingBox id={positionId}>
			{elements.map((element: TBannerItemNew, i: number) => {
				const { aspectRatio } = element;
				return (
					<ZoomSlidingCardBox
						key={i}
						onClick={(e) => {
							if (!element.link) {
								e.preventDefault();
							}
						}}
						// {...(element.link ? { href: element.link, target: aTarget } : {})}
						{...transformAParam({
							isInApp: !!isInApp,
							link: element?.link,
							aTarget,
						})}
						aspectRatio={aspectRatio}
					>
						<ImageView
							src={element.img}
							online={props.online}
							key={i}
							style={{}}
							placeholder={placeholderBg}
							fallbackSrc={placeholderBg}
						/>
					</ZoomSlidingCardBox>
				);
			})}
		</ZoomSlidingBox>
	);
};

export default CubeBannerBase;
